import React from "react";
import styled from "styled-components";
import { inject, observer } from "mobx-react";

const UpdatedHolder = styled.div`
  background-color: white;
  height: 49px;
  border: 1px solid #d2d2d2;
  padding: 5px;
  width: 100%;
  min-width: 270px;
  max-width: 877px;
  margin-right: 10px;
  border-radius: calc(0.25rem - 1px) calc(0.25rem - 1px) 0 0;
`;

const UpdatedTitle = styled.div`
  font-size: 13px;
  font-weight: bold;
`;

const UpdateInfo = styled.div`
  font-size: 11px;
`;

class AuditPcStrikeZoneInfo extends React.Component {
  render() {
    const auditPcStore = this.props.rootStore.auditPcStore;
    return (
      <UpdatedHolder>
        <div className="row">
          <div className="col-6">
            <UpdatedTitle>Updated On</UpdatedTitle>
            <UpdateInfo>{auditPcStore.selectedPitch.updatedOn}</UpdateInfo>
          </div>
          <div className="col-6">
            <UpdatedTitle>Updated By</UpdatedTitle>
            <UpdateInfo>{auditPcStore.selectedPitch.updatedBy}</UpdateInfo>
          </div>
        </div>
      </UpdatedHolder>
    );
  }
}

export default inject("rootStore")(observer(AuditPcStrikeZoneInfo));
